import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { TranslateLangPipe, IconComponent } from '@gs-2.0/shared';

@Component({
  selector: 'app-redirect-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, TranslateLangPipe, IconComponent],
  templateUrl: './redirect-confirmation-dialog.component.html',
  styleUrls: ['./redirect-confirmation-dialog.component.scss']
})
export class RedirectConfirmationDialogComponent {
  @Input() visible: boolean = false;
  @Input() charityName: string = '';
  @Input() fundName?: string;
  @Input() logoUrl: string = '';
  @Input() organizationName: string = '';
  @Input() redirectTarget: string = '';

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  private _confirming = false;

  onHide(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    if (!this._confirming) {
      this.cancel.emit();
    }
    this._confirming = false;
  }

  onConfirm(): void {
    this._confirming = true;
    this.confirm.emit();
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onCancel(): void {
    this.cancel.emit();
    this.visible = false;
    this.visibleChange.emit(false);
  }

  get redirectMessage(): string {
    const target = this.redirectTarget?.toUpperCase();
    return `contribute.redirect.${target?.toLowerCase()}_message`;
  }
}
